export default "__VITE_ASSET__a48dd506__"